import React from 'react';
import '../styles/App.css';
import Header from "./Header"
import Footer from './Footer';
import Content from './Content';
import '../styles/Modal.css';



class App extends React.Component {

  render() {
    return (
      <div className="wrapper table-responsive">
        <Header />
        <div className="content-wrapper">
          <Content />
        </div>
        <Footer />
      </div>
    )
  }
}

export default App
